import { Component } from '@angular/core';

@Component({
    selector: 'app-terminos',
    templateUrl: './terminos.component.html',
    styleUrls: ['./terminos.component.scss'],
    standalone: false
})
export class TerminosComponent {

}
